<div class="outer-container lea-reports-outer-container">
  <app-accordian [title]="'LEA Submission Reports'">
    <div class="reports-grid-container">
      <app-data-grid
        [config]="leaReportGridConfig"
        [pagedata]="leaReportData"
        [statusDataField]="'status'"
        [submittedStatusValues]="['Complete']"
        id="lea_reports_datagrid">
        <ng-template #actionsTemplate let-rowData>
          <div class="report-action-cell">
            <button
              type="button"
              class="action-icon-button"
              matTooltip="Download"
              matTooltipPosition="above"
              aria-label="Download report"
              (click)="downloadReport(rowData); $event.stopPropagation()">
              <img src="assets/images/neveda-images/download.svg" alt="Download" />
            </button>
          </div>
        </ng-template>
      </app-data-grid>
    </div>
  </app-accordian>
</div>
